import { render, staticRenderFns } from "./vue-multiselect-ajax.vue?vue&type=template&id=2f9be34c&scoped=true&"
import script from "./vue-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./vue-multiselect-ajax.vue?vue&type=script&lang=js&"
import style1 from "./vue-multiselect-ajax.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9be34c",
  null
  
)

export default component.exports